import { render, staticRenderFns } from "./infoModel.vue?vue&type=template&id=44be38cd"
import script from "./infoModel.vue?vue&type=script&lang=js"
export * from "./infoModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44be38cd')) {
      api.createRecord('44be38cd', component.options)
    } else {
      api.reload('44be38cd', component.options)
    }
    module.hot.accept("./infoModel.vue?vue&type=template&id=44be38cd", function () {
      api.rerender('44be38cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supervise/organizationManage/infoModel.vue"
export default component.exports